import Icon from 'flow/components/ui-components/Icon';
import { Tooltip } from 'flow/components/ui-components/Tooltip';
import { setSnackbar } from 'flow/actions/app-actions';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppDispatch } from 'flow/hooks/useRedux';

interface Props {
    text?: string;
    tooltipLabel?: string;
}

const CopyButton = ({ text, tooltipLabel }: Props) => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();

    const copyToClipboard = () => {
        if (!text) return;
        navigator.clipboard.writeText(text).then(() => {
            dispatch(
                setSnackbar({
                    message: i18next.t('snackbar.copied_to_clipboard'),
                }),
            );
        });
    };

    if (!text) return null;

    return (
        <Tooltip label={tooltipLabel || i18next.t('Tooltip.Title.Copy')}>
            <button
                aria-label={tooltipLabel || i18next.t('Tooltip.Title.Copy')}
                onClick={copyToClipboard}
                className="hover:darken-10 cursor-pointer rounded p-1"
            >
                <Icon
                    iconKey="copyOutlined"
                    size="1.25rem"
                    className="text-gray-600"
                />
            </button>
        </Tooltip>
    );
};

export default CopyButton;
